import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

const UtilityPage = lazy(() => import('src/pages/utilities/list-utility'));
const UtilityCreatePage = lazy(() => import('src/pages/utilities/create-utility'));
const UtilityEditPage = lazy(() => import('src/pages/utilities/edit-utility'));

export const utilityRoutes = [
  {
    path: 'utilities',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [
      { path: '', element: <UtilityPage />, index: true },
      { path: 'new', element: <UtilityCreatePage /> },
      { path: 'edit/:id', element: <UtilityEditPage /> },
    ],
  },
];
